import type { LogEntry } from "./boardbook-model";

const drafts = new Map<string, LogEntry>();
const pending = new Map<string, Promise<unknown>>();
export function prepareTimerDraft(id: string, work: () => Promise<unknown>): void {
  const job = Promise.resolve().then(work);
  pending.set(id, job);
  void job.finally(() => pending.delete(id)).catch(() => undefined);
}
export function pendingTimerDraft(id: string): Promise<unknown> | undefined {
  return pending.get(id);
}
const key = (id: string) => `efb.logbook.timerDraft.${id}`;

/** Keep a rejected timer entry available for review, including after a tab refresh. */
export function keepTimerDraft(entry: LogEntry): void {
  drafts.set(entry.id, structuredClone(entry));
  try {
    sessionStorage.setItem(key(entry.id), JSON.stringify(entry));
  } catch {
    /* Memory fallback. */
  }
}

export function readTimerDraft(id: string): LogEntry | undefined {
  const cached = drafts.get(id);
  if (cached) return structuredClone(cached);
  try {
    const entry = JSON.parse(sessionStorage.getItem(key(id)) || "null");
    return entry?.id === id ? entry : undefined;
  } catch {
    return undefined;
  }
}

export function removeTimerDraft(id: string): void {
  drafts.delete(id);
  try {
    sessionStorage.removeItem(key(id));
  } catch {
    /* Storage may be unavailable. */
  }
}

export function isOverlappingLeg(error: unknown): boolean {
  const failure = error as { code?: string; results?: { id: string }[] };
  return (
    failure?.code === "COORDINATOR_VIOLATION" &&
    failure.results?.some((result) => result.id === "leg-no-overlapping-siblings") === true
  );
}
